import _ from 'lodash';
import { DOSSIER_TYPES, TOAST_TYPES } from '../../constants/settings.constants';
import { offerings } from '../bff.api';
import responseValidators from '../response.validators';
import toastService from '../toasts.service';

const _updateBody = (data) => {
  const result = _.pick(data, [
    'title',
    'shortDescription',
    'description',
    'formSlug',
    'dossierType',
    'themes',
    'images',
    'visibleUnauthorized',
    'visibleCity',
    'visiblePartners',
    'visibleSchools'
  ]);

  if (result.dossierType === DOSSIER_TYPES.NONE) {
    result.formSlug = '';
  }

  return result;
};

const _createBody = (data) => {
  const result = _.pick(data, [
    'title',
    'shortDescription',
    'description',
    'formSlug',
    'dossierType',
    'themes',
    'images',
    'visibleUnauthorized',
    'visibleCity',
    'visiblePartners',
    'visibleSchools'
  ]);

  if (result.dossierType === DOSSIER_TYPES.NONE) {
    result.formSlug = '';
  }

  return result;
};

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const add = async (data, options = {}) => {
  return offerings
    .add(_createBody(data))
    .then((resp) => {
      responseValidators.addOffering(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const addImage = async (offeringId, file, options = {}) => {
  return offerings
    .addImage(offeringId, { image: file })
    .then((resp) => {
      responseValidators.addOfferingImage(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => {
      _handleError(err, options.onError);
      toastService.showToast(TOAST_TYPES.ERROR, err.message);
    });
};

const update = async (offeringId, data, options = {}) => {
  return offerings
    .update(offeringId, _updateBody(data))
    .then((resp) => {
      responseValidators.updateOffering(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const remove = async (offeringId, options = {}) => {
  return offerings
    .delete(offeringId)
    .then((resp) => {
      responseValidators.deleteOffering(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const removeImage = async (offeringId, name, options = {}) => {
  return offerings
    .deleteImage(offeringId, name)
    .then((resp) => {
      responseValidators.deleteOfferingImage(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => {
      _handleError(err, options.onError);
      toastService.showToast(TOAST_TYPES.ERROR, err.message);
    });
};

const adminOfferingsService = {
  add,
  addImage,
  update,
  remove,
  removeImage
};

export default adminOfferingsService;
